<template>
    <spinner :loading="loading">
        <div class="field is-grouped">
            <ref-code-display-selector
                :library-name="library.name"
                :columns="columns"
                @change="onChangeCodeRefDisplayMode" />
        </div>
    </spinner>
</template>

<script>
    import RefCodeDisplaySelector from './RefCodeDisplaySelector.vue';
    import { createCodeDefArray } from '@/shared/helpers/dataHelpers.ts';
    import Spinner from '@/shared/components/Spinner.vue';
    export default {
        components: {
            RefCodeDisplaySelector,
            Spinner
        },
        props: {
            library: {
                type: Object,
                required: true
            }
        },
        emits: [
            'coderef-display-mode'
        ],
        data() {
            return {
                columns: null,
                loading: true
            };
        },
        async mounted() {
            this.columns = createCodeDefArray(this.library.attributeDefinitions);
            this.loading = false;
        },
        methods: {
            onChangeCodeRefDisplayMode(col) {
                this.$emit('coderef-display-mode', (columns) => {
                    columns.find(c => c.field === col.field).referenceDisplayMode = col.referenceDisplayMode;
                });
            }
        }
    };
</script>

<style>

</style>
